var t={pagesList:"PagesList__pagesList-UNv",pageButton:"PagesList__pageButton-OZX",active:"PagesList__active-0Ux"};export{t as default};
